import { useEffect } from 'react'

import { onAuthStateChanged } from '@firebase/auth'
import { useNavigate } from 'react-router'

import brandPrimaryLogo from 'assets/images/mockingbird-logo-primary.png'
import MDBox from 'components/MDBox'
import { auth } from 'config/firebase'
import { setUser, useMaterialUIController } from 'context'
import PageLayout from 'modules/LayoutContainers/PageLayout'
import { ROUTE_PATHS } from 'routes'
import { initClientSession } from 'utils/session'

function SplashScreen(): JSX.Element {
	const [_, dispatch] = useMaterialUIController()
	const navigate = useNavigate()
	const DELAY_MS = 1000

	useEffect(() => {
		// eslint-disable-next-line no-undef
		let timerId: NodeJS.Timeout | null
		const unsubscribe = onAuthStateChanged(auth, async user => {
			if (user) {
				const clientData = await initClientSession(user)
				if (clientData) {
					setUser(dispatch, {
						user,
						data: {
							role: clientData.role,
							organisation: {
								id: clientData.orgId,
								logo: clientData.logo,
								name: clientData.name,
								default_location: clientData.default_location,
								members: clientData?.orgMembers,
							},
						},
					})
				} else {
					timerId = setTimeout(() => {
						setUser(dispatch, null)
						navigate(ROUTE_PATHS.AUTHENTICATION.SIGN_IN)
					}, DELAY_MS)
				}
			} else {
				timerId = setTimeout(() => {
					setUser(dispatch, null)
					navigate(ROUTE_PATHS.AUTHENTICATION.SIGN_IN)
				}, DELAY_MS)
			}
		})

		// Cleanup listener and timer on component unmount
		return () => {
			unsubscribe()
			if (timerId) {
				clearTimeout(timerId)
			}
		}
	}, [dispatch])

	return (
		<PageLayout>
			<MDBox
				display={'flex'}
				justifyContent={'center'}
				sx={{
					position: 'absolute', // Makes the box cover the entire screen
					top: 0,
					left: 0,
					minWidth: '100vw',
					minHeight: '100vh',
					'@keyframes pulse': {
						'0%': {
							transform: 'scale(1)',
							opacity: 0.6,
						},
						'50%': {
							transform: 'scale(1.5)',
							opacity: 1,
						},
						'100%': {
							transform: 'scale(1)',
							opacity: 0.6,
						},
					},
				}}
				alignItems={'center'}
				bgColor="grey-500"
			>
				<MDBox
					component="img"
					src={brandPrimaryLogo}
					alt="Brand"
					width="5rem"
					sx={{
						animation: 'pulse 2s infinite', // Use the embedded keyframes
					}}
				/>
			</MDBox>
		</PageLayout>
	)
}

export default SplashScreen
